// This was made to prevent require cycle in the app
export { useAuthContext as useAuth } from '~contexts'
